import { render, staticRenderFns } from "./ShipmentBatchesIndex.vue?vue&type=template&id=0a4f16f6&scoped=true&"
import script from "./ShipmentBatchesIndex.vue?vue&type=script&lang=js&"
export * from "./ShipmentBatchesIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentBatchesIndex.vue?vue&type=style&index=0&id=0a4f16f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f16f6",
  null
  
)

export default component.exports